import { Link } from "react-router-dom";
import { NAV, CONTACT } from "../data/site";

export const Footer = () => (
  <footer className="bg-ink px-5 pb-10 pt-20 text-paper sm:px-10 md:pt-28 lg:px-16" data-testid="site-footer">
    <div className="grid grid-cols-12 gap-y-14">
      <div className="col-span-12 md:col-span-5">
        <img src="/img/logo-light.png" alt="B Digital Studio" width="346" height="243" className="h-auto w-44 md:w-56" loading="lazy" />
      </div>
      <div className="col-span-6 md:col-span-2 md:col-start-7">
        <p className="eyebrow !text-mint/80">Pagine</p>
        <ul className="mt-5 space-y-3 text-sm">
          {[{ to: "/", label: "Home" }, ...NAV].map((n) => (
            <li key={n.to}><Link to={n.to} className="link-u text-paper/85" data-testid={`footer-nav-${n.label.toLowerCase()}`}>{n.label}</Link></li>
          ))}
        </ul>
      </div>
      <div className="col-span-6 md:col-span-3">
        <p className="eyebrow !text-mint/80">Contatti</p>
        <ul className="mt-5 space-y-3 text-sm text-paper/85">
          <li><a href={`mailto:${CONTACT.email}`} className="link-u break-all" data-testid="footer-email">{CONTACT.email}</a></li>
          <li>Lombardia · Como, Monza e Brianza, Varese, Lecco</li>
          <li><a href="https://www.instagram.com/b_digital_studio/" target="_blank" rel="noopener noreferrer" className="link-u" data-testid="footer-instagram">Instagram</a></li>
        </ul>
      </div>
    </div>
    <div className="mt-20 flex flex-col gap-4 border-t border-paper/15 pt-8 text-xs text-paper/70 md:flex-row md:items-center md:justify-between">
      <p>© {new Date().getFullYear()} B Digital Studio · P.IVA 04076810136</p>
      <div className="flex gap-6">
        <Link to="/privacy" className="link-u" data-testid="footer-privacy">Privacy policy</Link>
        <Link to="/cookie" className="link-u" data-testid="footer-cookie">Cookie policy</Link>
      </div>
    </div>
  </footer>
);
